import { observable, action } from 'mobx'
import Api from '@api/xiu_yan/jukeTreasureApi'
import { message, Modal } from 'hljd'
import { JUKE_PATH_A } from '@constant'

const confirm = Modal.confirm

class Store {
  @observable title = ''
  @observable has_prize = 0
  @observable people_limit = ''
  @observable activity_time = ''
  @observable content = ''
  @observable imgs = []
  @observable merchant_info = ''

  @observable visit_gift = ''
  @observable comment_gift = ''
  @observable order_gift = ''

  @action
  changeField = type => value => {
    this[type] = value
  }

  @action
  changeInput = type => e => {
    let pattern = /[^0-9.]/g

    if (type == 'people_limit') {
      if (pattern.test(e.target.value)) {
        this[type] = ''
      } else {
        this[type] = e.target.value
      }
    } else if (type == 'content') {
      if (e.target.value > 500) {
        this[type] = e.target.value.substring(0, 500)
      } else {
        this[type] = e.target.value
      }
    } else if (type == 'merchant_info') {
      if (e.target.value > 100) {
        this[type] = e.target.value.substring(0, 100)
      } else {
        this[type] = e.target.value
      }
    } else {
      this[type] = e.target.value
    }
  }

  @action
  AddImg = (img, { width, height }) => {
    this.imgs = [...this.imgs, { img, width, height }]
  }

  @action
  removeImg = index => {
    this.imgs = this.imgs.filter((item, i) => i !== index)
  }

  doCheck = () => {
    const { people_limit, activity_time, content, merchant_info } = this

    if (!people_limit) {
      return '活动名额不能为空'
    }

    if (people_limit > 200) {
      return '人数超过限制'
    }

    if (!activity_time) {
      return '活动时间不能为空'
    }

    if (!content) {
      return '活动内容不能为空'
    }

    if (!merchant_info) {
      return '商家简介不能为空'
    }

    return 'pass'
  }

  getParams = () => {
    const {
      title,
      has_prize,
      people_limit,
      activity_time,
      content,
      imgs,
      merchant_info,
      visit_gift,
      comment_gift,
      order_gift
    } = this

    let msg = this.doCheck()
    if (msg == 'pass') {
      return {
        title,
        has_prize,
        people_limit,
        activity_time,
        content,
        imgs,
        merchant_info,
        visit_gift,
        comment_gift,
        order_gift
      }
    } else {
      message.warning(msg)
      return false
    }
  }

  @observable disabled = false
  @action
  doApply = () => {
    let params = this.getParams()

    if (params) {
      this.disabled = true
      confirm({
        title: '确认申请该活动？',
        onOk: async () => {
          let { success } = await Api.apply(params)
          if (success) {
            message.success('申请成功，请耐心等待审核结果...')
            window.location.href = JUKE_PATH_A
          }
        }
      })
    }
  }
}
export default new Store()
